import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let groupsMountPromise = null;

export function initGroupsViewFragment({ onMounted } = {}) {
  registerViewMount('admin-groups', () => mountGroupsView(onMounted));
}

async function mountGroupsView(onMounted) {
  if (document.getElementById('view-admin-groups')) return;
  if (groupsMountPromise) return groupsMountPromise;

  groupsMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');

    await appendTrustedAdminViewFragment(host, '/admin-views/groups.html', 'Unable to load groups admin view');
    onMounted?.();
  })();

  try {
    await groupsMountPromise;
  } catch (error) {
    groupsMountPromise = null;
    throw error;
  }
}
